import React from 'react';
import PropTypes from 'prop-types';

// Style and SEO
import { css, up, styled, thd } from '@smooth-ui/core-sc';
import { Link } from 'react-router-dom';
import PrivateComponent from '_platform/src/utils/PrivateComponent';
import { withSettings } from 'containers/WebApp/SettingsContext';
import Heatleys from '../../../theme/heatleys.svg';

const FooterWrapper = styled.footer`
  background-color: ${thd('secondary', 'grey')};
`;

const TopBorder = styled.div`
  height: 10px;

  &.logged-in {
    height: 40px;
  }
`;

const FooterContainer = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  width: 100%;
  min-height: 62px;
  align-items: center;
  padding: 20px 10px 5px 10px;
  ${up(
    'md',
    css`
      flex-direction: row;
      justify-content: space-between;
      padding: 0 2rem;
    `
  )};

  .heatleys {
    width: 180px;
    height: 28px;
    margin-bottom: 10px;
    ${up(
      'md',
      css`
        margin-bottom: 0;
      `
    )};
  }

  p {
    color: #fff;
    font-size: 16px;
  }
  ul {
    margin: 0;
    padding: 0;
    list-style: none;
    display: flex;
    flex-direction: column;
    justify-content: center;
    ${up(
      'md',
      css`
        flex-direction: row;
      `
    )};
  }
  li {
    font-size: 16px;
    color: #fff;
    text-align: center;
    padding: 5px 0;
    ${up(
      'md',
      css`
        //border-right: 1px solid #fff;
        padding: inherit;
        text-align: left;
        &:nth-last-child(1) {
          border-right: none;
        }
      `
    )};
    a {
      color: #fff;
      font-weight: normal;
      text-decoration: none;
      padding: 0.1rem 1rem;
      &:hover {
        text-decoration: underline;
      }
    }
  }
`;

const Footer = ({ isLoggedIn }) => (
  <FooterWrapper>
    <TopBorder className={`${isLoggedIn ? '' : ''} gradient`} />
    <FooterContainer>
      <img src={Heatleys} alt="Heatleys" className="heatleys" />

      <PrivateComponent>
        <ul>
          <li>
            <Link to="/faqs">FAQs</Link>
          </li>

          <li>
            <Link to="/terms">Terms & Conditions</Link>
          </li>
          <li>
            <Link to="/privacy">Privacy Policy</Link>
          </li>
        </ul>
      </PrivateComponent>
    </FooterContainer>
  </FooterWrapper>
);

Footer.propTypes = {
  isLoggedIn: PropTypes.bool,
};

Footer.defaultProps = {
  isLoggedIn: false,
};

export default withSettings(Footer);
